<app-base-template (modal)="openModal(content)" (searchmodal) = "searchModal()" (dataExportToExcel)="exportToExcel()" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getNewTableData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded"[showExportBtn]="showExportBtn" [showSearch]="showSearch"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Role</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="rolename"
             placeholder="Enter User Role Name">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="roledesc"
             placeholder="Enter User Role Description">
    </div>
    <mat-checkbox [(ngModel)]="adminRlCheck">Is Admin Role</mat-checkbox>

    <!--<mat-slide-toggle (toggleChange)="slideChange()" [checked]="slideChecked"> <b class="blue"> This role is for Super Admin</b></mat-slide-toggle>-->
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">

      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Role Name"
                 [(ngModel)]="roleSelected"
                 matInput [formControl]="searchData"[matAutocomplete]="auto"
                >
          <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngIf="isLoading" class="is-loading">
                  <mat-spinner diameter="50"></mat-spinner>
              </mat-option>
              <ng-container *ngIf="!isLoading">
                  <mat-option *ngFor="let role of role" [value]="role.name">
                    {{ role.name }}
                  </mat-option>
              </ng-container>
          </mat-autocomplete>
      </div>
  </div>
  <div class="modal-footer pad-8">
          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>

  </ng-template>
<notifier-container></notifier-container>

